export default __webpack_public_path__ + "static/media/userPlaceholderAvatar.966b08b1.png";